import { addItemToCollection, addItemsToCollection } from "directus/src/operations";

export async function createTimesheetEntry({ item }) {
  try {
    const query = {
      fields: [
        "approved_hours",
        "date",
        "description",
        "employee.avatar",
        "employee.first_name",
        "employee.id",
        "employee.last_name",
        "id",
        "job.id",
        "job.name",
        "logged_hours",
        "milestone.id",
        "milestone.name",
        "project.id",
        "project.name",
        "unapproved_hours",
        "created_from_draft",
      ],
    };

    const data = await addItemToCollection("timesheet", item, query);

    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function createTimesheetEntries({ items }) {
  try {
    const query = {
      fields: [
        "approved_hours",
        "date",
        "description",
        "employee.avatar",
        "employee.first_name",
        "employee.id",
        "employee.last_name",
        "id",
        "job.id",
        "job.name",
        "logged_hours",
        "milestone.id",
        "milestone.name",
        "project.id",
        "project.name",
        "unapproved_hours",
        "created_from_draft",
      ],
    };

    const data = await addItemsToCollection("timesheet", items, query);

    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}
